export const appMode = [
  { value: "di_mode", label: "DI Mode" },
  // value stays "pos_mode" so existing users keep resolving to this label
  { value: "pos_mode", label: "FBR POS Mode" },
  { value: "pra_pos_mode", label: "PRA POS Mode" },
];

export const DI_APP_MODE = "di_mode";

// Modes that get the POS invoice screen instead of the standard Add Invoice one
export const POS_APP_MODES = ["pos_mode", "pra_pos_mode"];

/**
 * appMode is a list of modes, but records saved before multi-select hold a single
 * string (and lean() queries return it unchanged), so accept both shapes.
 */
export const normalizeAppModes = (value) => {
  if (Array.isArray(value)) return value.filter(Boolean);
  if (typeof value === "string" && value.trim()) {
    return value
      .split(",")
      .map((mode) => mode.trim())
      .filter(Boolean);
  }
  return [];
};

export const appModeLabels = (value) => {
  const modes = normalizeAppModes(value);
  if (!modes.length) return "-";
  return modes
    .map((mode) => appMode.find((item) => item.value === mode)?.label || mode)
    .join(", ");
};

export const hasPosMode = (value) =>
  normalizeAppModes(value).some((mode) => POS_APP_MODES.includes(mode));

export const hasDiMode = (value) =>
  normalizeAppModes(value).includes(DI_APP_MODE);

// "Other" must stay last — BlockUserModal keys its custom-reason input off this value.
export const OTHER_BLOCK_REASON = "Other";

export const blockReasons = [
  "Subscription Expired",
  "Payment Default",
  "Fraudulent Invoicing Activity",
  "Suspicious FBR Submission Activity",
  "Violation of Terms of Service",
  OTHER_BLOCK_REASON,
];
